export default function() {
    let _this = this;
     if(!this.DEBUG){
        if(!window.console) window.console = {};
        var methods = ["log", "debug", "warn", "info"];
        for(var i=0;i<methods.length;i++){
            console[methods[i]] = function(){};
        }
    }

     window.addEventListener("dsb-pwa-base_update", e => {
        if('detail' in e)
        {
            let update = e.detail;
            if('appname' in update)
            {
              document.getElementById("dsb-pwa_appname").innerHTML = update.appname;
            }
            if('app_tab_title' in update)
            {
              _this._app_tab_title = update.app_tab_title;
              _this._update_DocumentTitle();
            }
            if('title' in update)
            {
              document.getElementById("dsb-pwa_title").innerHTML = update.title;
            }
            if('layout' in update)
            {
              _this.setAttribute(`layout`, update.layout);
              _this._render();
            }
        }
     });

     window.addEventListener("dsb-pwa-append_tray", e => {
        try
        {
          if('detail' in e)
          {
            if(('onclick' in e.detail) && ('icon' in e.detail))
            {
              let tray_id = 'dsb-pwa_tray';
              if(('tray_id' in e.detail))
              {
                tray_id = e.detail.tray_id;
              }
              else if('iam' in e.detail)
              {
                if(typeof e.detail.iam == 'object' && e.detail.iam instanceof HTMLElement)
                {
                  tray_id = window.getTrayId(e.detail.iam);
                }
                else
                {
                  throw "e.detail.iam should be instanceof HTMLElement";
                }
              }
              else
              {
                throw "Missing tray target. Either (string)detail.tray_id or (HTMLElement)detail.iam of caller";
              }

              let workspace = window.getWorkspace(document.getElementById(tray_id));

              if(workspace == null || typeof workspace !== 'object')
              {
                throw 'Missing workspace!';
              }

              if(('init_append' in e.detail) && 'parentNode' in workspace)
              {
                workspace.parentNode.append(e.detail.init_append);
              }

              let tray_item_id = tray_id+'__'+e.detail.name;

              let element = document.createElement('div');
              element.setAttribute('class',e.detail.icon+' icon-clickable');
              if('name' in e.detail)
              {
                element.id = tray_item_id;
              }
              element.onclick = function(){e.detail.onclick};

              if(('online_only' in e.detail) && e.detail.online_only === true)
              {
                // If online only the item wil have click events removed and dissabled class added
                element.classList.add('fw_workspace__online_only');
                element.setAttribute('data-offlineonly_toggleClass','dissable-icon');
              }

              if('icon_size' in e.detail)
              {
                element.setAttribute('style','margin-left: 0px;font-size: '+e.detail.icon_size+';');
              }
              else
              {
                element.setAttribute('style','margin-left: 0px;font-size: 30px;');
              }
              if(('overlay' in e.detail) && (e.detail.overlay))
              {
                element.onclick = function(){
                  if(!this.classList.contains('active'))
                  {
                    // Set active item
                    let tray_items = this.parentElement.querySelectorAll(`div`);
                    if(tray_items !== undefined || tray_items.length > 0)
                    {
                      for(let i = 0; i < tray_items.length; i++)
                      {
                        if(tray_items[i].classList.contains('active'))
                        {
                          tray_items[i].click();
                        }
                      }
                    }
                  }
                  this.classList.toggle('active');
                  if(workspace !== null || typeof workspace == 'object')
                  {
                    workspace.querySelector('.dsb-workspace-overlay').classList.toggle('show');
                  }
                  e.detail.onclick();
                };

                //workspace.querySelector('.dsb-workspace-overlay').setAttribute('data-trayId',tray_id);

                workspace.querySelector('.dsb-workspace-overlay').onclick=function(){
                  //this.getAttribute('data-trayId')
                  let tray_items = document.getElementById(tray_id).parentElement.querySelectorAll(`div`);
                  if(tray_items !== undefined || tray_items.length > 0)
                  {
                    for(let i = 0; i < tray_items.length; i++)
                    {
                      console.error(tray_items[i]);
                      if(tray_items[i].classList.contains('active'))
                      {
                        tray_items[i].click();
                      }
                    }
                  }
                };
              }
              else
              {
                element.onclick = function(){e.detail.onclick()};
              }
              element.innerHTML = '<span style="padding-right:10px;">&nbsp;<span>';
              document.getElementById(tray_id).prepend(element);
            }
          }
        }
        catch(ex)
        {
          console.error('dsb-pwa-append_tray:: Error occured in detail',ex,e);
        }
     });

     window.addEventListener("dsb-pwa-trigger_tray", e => {
        try
        {
          if('detail' in e)
          {
            let tray_id = 'dsb-pwa_tray';
            if(('tray_id' in e.detail))
            {
              tray_id = "dsb-pwa_tray__"+e.detail.tray_id;
            }
            if(('name' in e.detail))
            {
              document.getElementById(tray_id+"__"+e.detail.name).click();

            }
            else
            {
                console.error('dsb-pwa-trigger_tray:: No name supplied?');
            }
          }
        }
        catch(ex)
        {
          console.error('dsb-pwa-trigger_tray:: Error occured in detail',ex);
        }
     });

     window.addEventListener("dsb-pwa-toggle_full_screen", e => {
        try
        {
          if('detail' in e)
          {
            if(('source_id' in e.detail))
            {
              let elem = document.getElementById(e.source_id);
              if (elem.requestFullscreen) {
                elem.requestFullscreen();
              } else if (elem.webkitRequestFullscreen) { /* Safari */
                elem.webkitRequestFullscreen();
              } else if (elem.msRequestFullscreen) { /* IE11 */
                elem.msRequestFullscreen();
              }
            }
            else
            {
              console.error('dsb-pwa-toggle_full_screen:: detail.source_id missing');
            }
          }
          else
          {
            if (document.exitFullscreen) {
              document.exitFullscreen();
            } else if (document.webkitExitFullscreen) { /* Safari */
              document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) { /* IE11 */
              document.msExitFullscreen();
            }
          }
        }
        catch(ex)
        {
          console.error('dsb-pwa-toggle_full_screen:: Error occured in detail',ex);
        }
     });

     window.addEventListener("dsb-pwa-add_modal", e => {
        try
        {
          if('detail' in e)
          {
            if(!('id' in e.detail))
            {
              e.detail.id=_this._createUUID();
            }
            let zindex = false;
            if(('iam' in e.detail))
            {
              zindex = window.getZIndex(e.detail.iam);
            }


            let element = document.createElement('dsb-modal');
            element.id = 'dsb-add_modal__'+e.detail.id;

            let workspace = document.createElement("dsb-workspace");
            let html = `
            <header>
              <ul>
                <li class="title"></li>
                <li class="logo"><a href="" onclick="return false;"><img src="`+this.logo+`" alt="Farmers Weekly"/></a></li>
                <li class="tray" id="dsb-pwa_tray__`+e.detail.id+`">
                  <div id="dsb-pwa_tray_close__`+e.detail.id+`" class="m-icon-close icon-clickable" style="margin-left: 0px;font-size: 25px;">
                    <span style="padding-right:10px;">&nbsp;<span></span></span>
                  </div>
                </li>
              </ul>
            </header>`;
            if('content' in e.detail)
            {
              if(e.detail.content instanceof HTMLElement)
              {
                if(e.detail.content.tagName == 'DSB-WORKSPACE')
                {
                  workspace = e.detail.content;
                }
                else
                {
                  workspace.append(e.detail.content);
                }
              }
              else
              {
                  workspace.innerHTML = e.detail.content;
              }
            }

            var overlay = document.createElement("div");
            overlay.setAttribute(`class`,"dsb-workspace-overlay");
            workspace.append(overlay);

            element.innerHTML = html;
            element.append(workspace);
            this.append(element);

            if(zindex)
            {
              element.style.zIndex = zindex+1;
            }

            document.getElementById(`dsb-pwa_tray_close__`+e.detail.id+``).onclick = function(){
              document.getElementById(element.id).classList.toggle('show');
              // Reset app title
              _this._update_DocumentTitle('');
            };

            this.add_feedback('dsb-pwa_tray__'+e.detail.id);
          }
        }
        catch(ex)
        {
          console.error('dsb-pwa-add_modal:: Error occured in detail',ex);
        }
     });

     window.addEventListener("fw-workspace-check_for_update", e => {
        try
        {
          if(('check_for_update' in _this.setting) && _this.setting.check_for_update=='on')
          {
            if(('app_hash_url' in _this.setting) && ('app_hash' in _this.setting)  && ('app_name' in _this))
            {

              let didTimeOut = false;
              const timeout = setTimeout(function() {
                  didTimeOut = true;
                  reject(new Error('Request timed out @'+_this.setting.app_hash_url));
              }, 5000);

             fetch(_this.setting.app_hash_url+'#sw:no-cache')
              .then(function(response) {
                  // Clear the timeout as cleanup
                  clearTimeout(timeout);

                  if(!didTimeOut) {
                      if(response.ok)
                      {
                        response.json().then(hash =>
                        {
                            if(hash !== null && typeof hash === 'object' && _this.app_name in hash && 'hash' in hash[_this.app_name])
                            {
                              let has_update = false;
                              if(hash[_this.app_name].hash !== _this.setting.app_hash)
                              {
                                has_update=true;
                                _this._log('info','event:fw-workspace-check_for_update','New update found',{"my_hash":_this.setting.app_hash,"your_hash":hash[_this.app_name].hash});
                              }
                              else
                              {
                                _this._log('info','event:fw-workspace-check_for_update','No updates',{"my_hash":_this.setting.app_hash,"your_hash":hash[_this.app_name].hash});
                              }

                              let update_indicator = document.getElementById('fw_workspace__update_indicator');
                              if(update_indicator!==null &&  typeof update_indicator === 'object' && update_indicator instanceof HTMLElement)
                              {
                                if(has_update)
                                {
                                  update_indicator.style.setProperty('--flash-color_from','#4a4a4a');
                                  update_indicator.style.setProperty('--flash-color_to','#d2222a');
                                  update_indicator.classList='m-icon-update icon-clickable flash-color';
                                }
                                else
                                {
                                  update_indicator.classList='icon-refresh icon-clickable';
                                }
                              }

                            }
                            else
                            {
                              _this._log('error','event:fw-workspace-check_for_update','Response for fetch('+_this.setting.app_hash_url+') malformed!',hash);
                            }
                        });

                      }
                      else
                      {
                         _this._log('error','event:fw-workspace-check_for_update','Response for fetch('+_this.setting.app_hash_url+') error!',response);
                      }
                  }
              })
              .catch(function(err) {
                  _this._log('error','event:fw-workspace-check_for_update','fetch failed! ', err);
                  // Rejection already happened with setTimeout
                   clearTimeout(timeout);
                  if(didTimeOut) return;
                  // Reject with error
                  reject(err);
              });


            }
            else
            {
              _this._log('warn','event:fw-workspace-check_for_update','Update checking off, no app_hash_url or app_hash found!');
            }
          }
          else
          {
            _this._log('debug','event:fw-workspace-check_for_update','Update checking off');
          }
        }
        catch(ex)
        {
          _this._log('error','event:fw-workspace-check_for_update','Unexpected error', ex);
        }
     });

     window.addEventListener("fw-workspace-offline_status", e => {
        try
        {
          let offline_element = document.getElementsByClassName('fw_workspace__offline_indicator');
          for (var i = 0; i < offline_element.length; i++)
          {
            if(offline_element[i] && offline_element[i] instanceof HTMLElement)
            {
              if('detail' in e)
              {
                if(e.detail)
                {
                  offline_element[i].style.display = 'inline-block';
                }
                else
                {
                  offline_element[i].style.display = 'none';
                }
              }
            }
          }

          offline_element = document.getElementsByClassName('fw_workspace__online_only');
          for (var i = 0; i < offline_element.length; i++)
          {
            if(offline_element[i] && offline_element[i] instanceof HTMLElement)
            {
              if('detail' in e)
              {
                let toggleClass = offline_element[i].getAttribute('data-offlineonly_toggleClass');
                if(e.detail)
                {
                  if('onclick' in offline_element[i])
                  {
                    offline_element[i]._fw_workspace__online_only__onclick=offline_element[i].onclick;
                    offline_element[i].onclick=function(){};
                    if(!offline_element[i].classList.contains(toggleClass))
                    {
                      offline_element[i].classList.add(toggleClass);
                    }
                  }
                }
                else
                {
                  if('_fw_workspace__online_only__onclick' in offline_element[i])
                  {
                    offline_element[i].onclick=offline_element[i]._fw_workspace__online_only__onclick;
                    if(offline_element[i].classList.contains(toggleClass))
                    {
                      offline_element[i].classList.remove(toggleClass);
                    }
                  }
                }
              }
            }
          }

        }
        catch(ex)
        {
          console.error('fw-workspace-offline_status:: Error occured in detail',ex);
        }
     });

     window.addEventListener("fw-workspace-add_scheduled_task", e => {
        try
        {
          if('detail' in e)
          {
            if(('slot' in e.detail) && ('task' in e.detail) && typeof e.detail.task === 'function')
            {
              if(!(e.detail.slot in this._cronIntervals))
              {
                switch(e.detail.slot)
                {
                  case "1min":
                    this._cronIntervals[e.detail.slot]=[];
                    this._cronIntervals[e.detail.slot].push(e.detail.task);
                    setInterval(function(){
                      for(let i=0; i<this._cronIntervals[e.detail.slot].length;i++)
                      {
                        if(typeof e.detail.task === 'function')
                        {
                          this._cronIntervals[e.detail.slot][i]();
                        }
                      }
                    },1000);
                    break;
                  default:
                    break;
                }
              }
              else
              {
                this._cronIntervals[e.detail.slot].push(e.detail.task);
              }

            }
            else
            {
              _this._log('error','event:fw-workspace-add_scheduled_task','Missing e.detail.slot, e.detail.task or task is not a function');
            }
          }
        }
        catch(ex)
        {
          _this._log('error','event:fw-workspace-add_scheduled_task','Error occured in detail', ex);
        }
     });

     window.addEventListener("fw-workspace-trigger_message", e => {
        try
        {
          if('detail' in e)
          {
            if('message' in e.detail)
            {
              let message_panel = document.getElementById('fw_workspace__message_stack');
              if(message_panel && message_panel instanceof HTMLElement)
              {
                 // Ok
              }
              else
              {
                let message_panel_target = null;
                if(('iam' in e.detail))
                {
                  message_panel_target = window.getWorkspace(e.detail.iam);
                }
                else
                {
                  message_panel_target = window.getWorkspace(_this);
                }

                if(message_panel_target instanceof HTMLElement)
                {
                  let message_panel = document.createElement("div");
                  message_panel.id='fw_workspace__message_stack';
                  message_panel.classList='slidedown-message hide';
                  message_panel.style="display:none";
                  message_panel.onclick=function(){
                    message_panel.classList='slidedown-message hide';
                  };
                  message_panel_target.prepend(message_panel);
                  setTimeout(function(){
                    message_panel.classList='slidedown-message show';
                    message_panel.style="";
                  },2000);

                }
                else
                {
                  _this._log('error','event:fw-workspace-trigger_message','Cannot find workspace');
                }
              }
              let message_panel_content = document.createElement("div");
              message_panel_content.innerHTML=e.detail.message;
              message_panel.append(message_panel_content);
              if(('onclick' in e.detail) && typeof e.detail.onclick == 'function')
              {
                message_panel.onclick=e.detail.onclick;
              }
            }
            else
            {
              _this._log('error','event:fw-workspace-trigger_message','e.detail.message missing');
            }


          }
          else
          {
            _this._log('error','event:fw-workspace-trigger_message','e.detail is missing');
          }
        }
        catch(ex)
        {
          _this._log('error','event:fw-workspace-trigger_message','General error has occured',ex);
        }
     });

     window.addEventListener("dsb-pwa-transient_modal", e => {
        try
        {
          if('detail' in e)
          {
            if(('content' in e.detail) && e.detail.content instanceof HTMLElement)
            {

              let hide = [];
              if('hide' in e.detail)
              {
                hide = e.detail.hide;
              }

              let id = _this._createUUID();
              let modal = document.createElement('dsb-modal');
              modal.id = 'dsb-add_modal__'+id;

              modal.innerHTML = `
              `+(hide.indexOf('header')<0?`
              <header>
                <ul>
                  <li class="title"></li>
                  <li class="logo"><a href="" onclick="return false;"><img src="`+this.logo+`" alt="Farmers Weekly"/></a></li>
                  <li class="tray" id="dsb-pwa_tray__`+id+`">
                    `+(hide.indexOf('refresh')<0?`
                    <div id="dsb-pwa_tray_rebuild__`+id+`" class="icon-refresh icon-clickable" style="margin-left: 0px;font-size: 25px;">
                      <span style="padding-right:0px;">&nbsp;<span></span></span>
                    </div>
                     `:'')+`
                    `+(hide.indexOf('close')<0?`
                    <div id="dsb-pwa_tray_close__`+id+`" class="m-icon-close icon-clickable" style="margin-left: 0px;font-size: 25px;">
                      <span style="padding-right:10px;">&nbsp;<span></span></span>
                    </div>
                    `:'')+`
                    <div id="dsb-pwa_offline__`+id+`" class="m-icon-offline fw_workspace__offline_indicator" style="display:none;margin-left: 0px;font-size: 25px;">
                      <span style="padding-right:10px;">&nbsp;<span></span></span>
                    </div>
                  </li>
                </ul>
              </header>
               `:'')+`
              <dsb-workspace></dsb-workspace>
              `;
              this.append(modal);

              if('action' in e.detail && e.detail.action == 'refresh')
              {
                document.getElementById(`dsb-pwa_tray_rebuild__`+id+``).className='icon-refresh icon-rotate icon-clickable';
              }

              let workspace = modal.querySelector('dsb-workspace');
              if(workspace != null && typeof workspace === 'object')
              {
                var overlay = document.createElement("div");
                overlay.setAttribute(`class`,"dsb-workspace-overlay");
                workspace.innerHTML = ``;
                workspace.append(overlay);
                workspace.append(e.detail.content);
                let feedback_aside_iframe=document.getElementById("feedback_aside_dsb-pwa_tray__"+id);
                if(feedback_aside_iframe != null && typeof feedback_aside_iframe === 'object')
                {
                  if(e.detail.content != null && typeof e.detail.content === 'object' && `link_path` in e.detail.content && e.detail.content.link_path != null)
                  {
                    feedback_aside_iframe.setAttribute('data-append_location','/modal/'+e.detail.content.link_path);
                    console.log('Updating feedback_aside data-append_location to /modal/'+e.detail.content.link_path);
                  }
                }
              }
              else
              {
                throw "workspace missing for modal "+modal.id;
              }

              if(hide.indexOf('close')<0)
              {
                document.getElementById(`dsb-pwa_tray_close__`+id+``).onclick = function(){
                  // Reset app title
                  _this._update_DocumentTitle('');
                  // Delete Modal
                  modal.outerHTML="";
                };
              }

              if(hide.indexOf('refresh')<0)
              {
                document.getElementById(`dsb-pwa_tray_rebuild__`+id+``).onclick = function(){
                  // Reset app title
                  _this._update_DocumentTitle('');
                  // Delete Modal
                  modal.outerHTML="";
                  // Rebuild
                  if('reset' in e.detail.content && typeof e.detail.content.reset == 'function')
                  {
                    e.detail.content.reset();
                  }
                  else
                  {
                    e.detail.content.innerHTML = '';
                  }
                  window.dispatchEvent(new CustomEvent('dsb-pwa-transient_modal', {detail: {content:e.detail.content,action:'refresh',hide:hide}}));
                };
              }

              if(hide.indexOf('feedback')<0)
              {
                this.add_feedback('dsb-pwa_tray__'+id);
              }

              if(!modal.classList.contains('show'))
              {
                if('action' in e.detail && e.detail.action == 'refresh')
                {
                  // Ok, do nothing
                }
                else
                {
                  if('mode' in e.detail)
                  {
                    modal.classList.add(e.detail.mode);
                  }
                  else
                  {
                    modal.classList.add('fadeIn');
                  }
                }
                modal.classList.toggle('show');
              }

            }
            else
            {
              throw "Missing detail.content or not instanceof HTMLElement... nothing to do!";
            }
          }
        }
        catch(ex)
        {
          console.error('dsb-pwa-add_modal:: Error occured in detail',ex);
        }
     });

     window.addEventListener("dsb-pwa-trigger_modal", e => {
        try
        {
          if('detail' in e)
          {
            if(('id' in e.detail))
            {
              let modal = document.getElementById('dsb-add_modal__'+e.detail.id);
              if(modal != null)
              {
                if(('append' in e.detail))
                {
                  let workspace = modal.querySelector('dsb-workspace');
                  if(workspace != null && typeof workspace === 'object')
                  {
                    let overlay = workspace.querySelector('.dsb-workspace-overlay')
                    workspace.innerHTML = ``;
                    workspace.append(overlay);
                    workspace.append(e.detail.append);
                    let feedback_aside_iframe=document.getElementById("feedback_aside_dsb-pwa_tray__"+e.detail.id);
                    if(feedback_aside_iframe != null && typeof feedback_aside_iframe === 'object')
                    {
                      if(e.detail.append != null && typeof e.detail.append === 'object' && `link_path` in e.detail.append && e.detail.append.link_path != null)
                      {
                        feedback_aside_iframe.setAttribute('data-append_location','/modal/'+e.detail.append.link_path);
                        console.log('Updating feedback_aside data-append_location to /modal/'+e.detail.append.link_path);
                      }
                    }
                  }
                }

                if(!modal.classList.contains('show'))
                {
                  modal.classList.toggle('show');
                }
              }
            }
          }
        }
        catch(ex)
        {
          console.error('dsb-pwa-trigger_tray:: Error occured in detail',ex);
        }
     });

     window.addEventListener("dsb-app-throwError", e => {

        let _type = '';
        if('type' in e)
        {
            _type = e.type;
        }

        let _message = '';
        if('message' in e)
        {
            _message = e.message;
        }

        switch(_type)
        {
          default:
            console.error(message);
            break;
        }
     });

     window.addEventListener("dsb-pwa-throwError", e => {

        if('detail' in e)
        {
          let _type = '';
          if('type' in e.detail)
          {
              _type =  e.detail.type;
          }

          let _message = '';
          if('message' in e.detail)
          {
              _message = e.detail.message;
          }

          console.error('Error: Type='+_type,_message);

          switch(_type)
          {
            default:
              break;
          }
        }
        else
        {
          console.error(e);
        }
     });

      window.addEventListener("dsb-pwa-add_pulldown_refresh", e => {
        try
        {
          if('detail' in e)
          {

            if('iam' in e.detail)
            {
              if(typeof e.detail.iam == 'object' && e.detail.iam )
              {
                let _this = e.detail.iam;

                if('_refresh' in _this && typeof _this._refresh == 'function')
                {
                  const pStart = { x: 0, y: 0 };
                  const pCurrent = { x: 0, y: 0 };

                  let refresh_panel_target = false;
                  let refresh_panel = document.createElement("div");
                  refresh_panel.classList='pulldown-refresh';
                  refresh_panel.innerHTML = `<maa-spinner type="inline-small"></maa-spinner>`;

                  console.debug('dsb-pwa-add_pulldown_refresh:: Setting up',_this);

                  let loadPulldown = async function() {
                    // Find workspace
                    if(!refresh_panel_target)
                    {
                      refresh_panel_target = window.getWorkspace(_this);
                      if(!(refresh_panel_target instanceof HTMLElement))
                      {
                        refresh_panel_target = _this;
                      }
                    }
                    // Pulldown refresh
                    if(!(refresh_panel_target.querySelector('.pulldown-refresh') instanceof HTMLElement))
                    {
                      console.debug('dsb-pwa-add_pulldown_refresh:: Adding pulldown_refresh panel',_this);
                      refresh_panel.classList='pulldown-refresh';
                      refresh_panel_target.prepend(refresh_panel);
                    }

                    if(refresh_panel.classList.contains('hide'))
                    {
                      refresh_panel.classList='pulldown-refresh';
                    }

                    if(!refresh_panel.classList.contains('show'))
                    {
                      console.debug('dsb-pwa-add_pulldown_refresh:: Refreshing...',_this);
                      refresh_panel.classList.add('show');
                      let _refresh = await _this._refresh();
                      refresh_panel.classList.remove('show');
                      refresh_panel.classList.add('hide');
                    }
                    else
                    {
                      console.error('do nothing...');
                    }
                  };
                  _this.addEventListener("touchstart", e => {
                    try
                    {
                      if (typeof e["targetTouches"] !== "undefined") {
                        let touch = e.targetTouches[0];
                        pStart.x = touch.screenX;
                        pStart.y = touch.screenY;
                      } else {
                        pStart.x = e.screenX;
                        pStart.y = e.screenY;
                      }
                    }
                    catch(ex)
                    {
                      console.error('DSBWorkspace-touchstart:: Error occured in detail',ex,e);
                    }
                  });
                  _this.addEventListener("touchmove", e => {
                    try
                    {
                      if (typeof e["changedTouches"] !== "undefined") {
                        let touch = e.changedTouches[0];
                        pCurrent.x = touch.screenX;
                        pCurrent.y = touch.screenY;
                      } else {
                        pCurrent.x = e.screenX;
                        pCurrent.y = e.screenY;
                      }
                      let changeY = pStart.y < pCurrent.y ? Math.abs(pStart.y - pCurrent.y) : 0;
                      if (_this.scrollTop === 0) {
                        if (changeY > 100) loadPulldown();
                      }
                    }
                    catch(ex)
                    {
                      console.error('dsb-pwa-add_pulldown_refresh:: Error occured in detail',ex,e);
                    }
                  });
                  _this.addEventListener("touchend", e => {
                    try
                    {
                      if (_this.scrollTop === 0 && !refresh_panel) {
                        console.error('Ok.. at top and no loading...');
                      }
                    }
                    catch(ex)
                    {
                      console.error('DSBWorkspace-touchend:: Error occured in detail',ex,e);
                    }
                  });
                }
                else
                {
                  throw "e.detail.iam needs to expose a '_refresh' function";
                }
              }
              else
              {
                throw "e.detail.iam should be instanceof HTMLElement";
              }
            }
            else
            {
              throw "e.detail.iam missing";
            }
          }
          else
          {
            throw "e.detail missing";
          }
        }
        catch(ex)
        {
          console.error('dsb-pwa-add_pulldown_refresh:: Error occured in detail',ex);
        }
      });


      window.fw_workbench = {};

      window.fw_workbench.getAppStyleProperties = function (type,property)
      {
        switch(type)
        {
          case "app":
              return getComputedStyle(document.querySelector('dsb-app'))[property];
          case "header":
              return getComputedStyle(document.querySelector('dsb-app > header'))[property];
          case "nav":
              return getComputedStyle(document.querySelector('dsb-app > nav'))[property];
          case "workspace":
              return getComputedStyle(document.querySelector('dsb-app > dsb-workspace'))[property];
          default:
              break;
        }
        return false;
      }

      window.fw_workbench.getApp = function ()
      {
        let app = document.querySelector('dsb-app');
        if(app != null && typeof app === 'object' && app instanceof HTMLElement)
        {
          return app;
        }
        return false;
      }

      // thanks to Craig Buckler: https://www.sitepoint.com/javascript-generate-lighter-darker-color/
      window.fw_workbench.getColorLuminance = function(hex, lum){

        // validate hex string
        hex = String(hex).replace(/[^0-9a-f]/gi, '');
        if (hex.length < 6) {
          hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
        }
        lum = lum || 0;

        // convert to decimal and change luminosity
        var rgb = "#", c, i;
        for (i = 0; i < 3; i++) {
          c = parseInt(hex.substr(i*2,2), 16);
          c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
          rgb += ("00"+c).substr(c.length);
        }

        return rgb;
      };

      window.fw_workbench.smoothScroll = function(target,to=0)
      {
          var smoothScrollFeature = 'scrollBehavior' in document.documentElement.style;
          var i = parseInt(target.scrollTop);
          if ( i != to ) {
              if (!smoothScrollFeature) {
                  to = parseInt(to);
                  if (i < to) {
                      var int = setInterval(function() {
                          if (i > (to-20)) i += 1;
                          else if (i > (to-40)) i += 3;
                          else if (i > (to-80)) i += 8;
                          else if (i > (to-160)) i += 18;
                          else if (i > (to-200)) i += 24;
                          else if (i > (to-300)) i += 40;
                          else i += 60;
                          target.scroll(0, i);
                          if (i >= to) clearInterval(int);
                      }, 15);
                  }
                  else {
                      var int = setInterval(function() {
                          if (i < (to+20)) i -= 1;
                          else if (i < (to+40)) i -= 3;
                          else if (i < (to+80)) i -= 8;
                          else if (i < (to+160)) i -= 18;
                          else if (i < (to+200)) i -= 24;
                          else if (i < (to+300)) i -= 40;
                          else i -= 60;
                          target.scroll(0, i);
                          if (i <= to) clearInterval(int);
                      }, 15);
                  }
              }
              else {
                  target.scroll({
                      top: to,
                      behavior: 'smooth'
                  });
              }
          }
      };

      window.getZIndex = function (e) {
        var z = window.document.defaultView.getComputedStyle(e).getPropertyValue('z-index');
        if (isNaN(z)) return window.getZIndex(e.parentNode);
        return z;
      };

      window.getWorkspace = function (e) {
        let aParent = e.parentNode;
        if(aParent != null && typeof aParent === 'object')
        {
          let workspace = aParent.querySelector('dsb-workspace');
          if(workspace != null && typeof workspace === 'object')
          {
            return workspace;
          }
          return window.getWorkspace(aParent);
        }
        return false;
      };
      window.getTrayId = function (e) {
        let aParent = e.parentNode;
        if(aParent != null && typeof aParent === 'object')
        {
          let tray = aParent.querySelector('.tray');
          if(tray != null && typeof tray === 'object' && ('id' in tray && tray.id.startsWith('dsb-pwa_tray')))
          {
            return tray.id;
          }
          return window.getTrayId(aParent);
        }
        return false;
      };

  }
